module.exports = __webpack_public_path__ + "static/img/banner_cgw.53048a7e.jpg";